export enum ReplyType {
  Reply = 1,
  ReplyAll = 2,
  Forward = 3,
}
